import { render, staticRenderFns } from "./CatalogLayoutsListsModal.vue?vue&type=template&id=893c6592&scoped=true"
import script from "./CatalogLayoutsListsModal.vue?vue&type=script&lang=js"
export * from "./CatalogLayoutsListsModal.vue?vue&type=script&lang=js"
import style0 from "./CatalogLayoutsListsModal.vue?vue&type=style&index=0&id=893c6592&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893c6592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('893c6592')) {
      api.createRecord('893c6592', component.options)
    } else {
      api.reload('893c6592', component.options)
    }
    module.hot.accept("./CatalogLayoutsListsModal.vue?vue&type=template&id=893c6592&scoped=true", function () {
      api.rerender('893c6592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/CatalogLayoutsListsModal.vue"
export default component.exports